import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  cover: string;
  rating: number;
  year: number;
  categoryName: string;
  duration: string;
  views: string;
  isHot?: boolean;
  isNew?: boolean;
}

export default function VideoCard({
  id,
  title,
  cover,
  rating,
  year,
  categoryName,
  duration,
  views,
  isHot,
  isNew,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-video overflow-hidden bg-background-200">
        <img
          src={cover}
          alt={title}
          title={`${title} - 嫩草视频高清在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          {isHot && (
            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary-500 text-white whitespace-nowrap">
              热门
            </span>
          )}
          {isNew && (
            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
              新上
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-white text-xs font-medium">{rating}</span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <span className="text-white text-xs">{duration}</span>
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <i className="ri-play-fill text-white text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-2 text-xs text-foreground-500">
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
            {categoryName}
          </span>
          <span>{year}</span>
          <span className="flex items-center gap-0.5">
            <i className="ri-eye-line"></i>
            {views}
          </span>
        </div>
      </div>
    </Link>
  );
}